module.exports = __webpack_public_path__ + "static/img/flash-kill-bg.2a24d2ef.png";